import React from 'react';
import styled from 'styled-components';
import { images } from 'config';

const toggleValue = () => this.props.toggleHighlights();

const ShowMore = () => (
  <Content OnClick={toggleValue}>
    <span>Show More</span>
    <img src={images.icons.forward} alt="Show more" />
  </Content>
);

export default ShowMore;

const Content = styled.div`
  cursor: pointer;

  &:hover {
    img {
      transform: scale(0.8) rotate(90deg) translateX(2px);
    }
  }
  span,
  img {
    display: inline-block;
    vertical-align: middle;
  }

  span {
    color: #fff;
    font-size: 14px;
  }
  img {
    filter: brightness(0) invert(1);
    transform: scale(0.8) rotate(90deg) translateY(0);
    transition: all 0.2s ease-in;
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/showMore/showMore.js